import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '../../lib/cn'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-11 w-full rounded-xl border border-[var(--border)] bg-[var(--surface)] px-3.5 text-base text-[var(--foreground)] shadow-sm outline-none transition',
        'placeholder:text-[var(--muted-foreground)] focus:border-[var(--primary)] focus:ring-3 focus:ring-[var(--primary-soft)]',
        'disabled:cursor-not-allowed disabled:bg-[var(--muted)] disabled:opacity-70',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'
